import { isEqual } from 'lodash';
import {
  InvestorAccessPermission,
  EisInvestorAccessPermissionGroup,
  EisInvestorAccessPermissionGroupKey,
  LpInvestorAccessPermissionGroup,
  LpInvestorAccessPermissionGroupKey,
} from 'further-types/further-user';

// EIS variants

export const EisInvestorAccessPermissionGroupNames: Record<
  EisInvestorAccessPermissionGroupKey,
  string
> = {
  Full: 'Full access',
  ReadOnly: 'Read-only',
};

export const getEisInvestorPermissionsGroup = (
  permissions: Array<InvestorAccessPermission>,
  returnAsKey = false,
) => {
  const keys = Object.keys(EisInvestorAccessPermissionGroup) as Array<
    keyof typeof EisInvestorAccessPermissionGroup
  >;

  const presetPermissionsGroup = keys.find((key) =>
    isEqual(
      new Set(permissions),
      new Set(EisInvestorAccessPermissionGroup[key]),
    ),
  );
  if (!presetPermissionsGroup) {
    return returnAsKey ? 'custom' : 'Custom';
  }

  return returnAsKey
    ? presetPermissionsGroup
    : EisInvestorAccessPermissionGroupNames[presetPermissionsGroup];
};

export const getEisInvestorAccessPermissionGroupOptions = () => {
  return (
    Object.keys(
      EisInvestorAccessPermissionGroup,
    ) as Array<EisInvestorAccessPermissionGroupKey>
  ).map((key) => ({
    label: EisInvestorAccessPermissionGroupNames[key],
    value: key,
  }));
};

// LP variants

export const LpInvestorAccessPermissionGroupNames: Record<
  LpInvestorAccessPermissionGroupKey,
  string
> = {
  Full: 'Full access',
  ReadOnly: 'Read-only',
  FullExceptSigning: 'Full access except signing',
};

export const getLpInvestorPermissionsGroup = (
  permissions: Array<InvestorAccessPermission>,
  returnAsKey = false,
) => {
  const keys = Object.keys(LpInvestorAccessPermissionGroup) as Array<
    keyof typeof LpInvestorAccessPermissionGroup
  >;

  const presetPermissionsGroup = keys.find((key) =>
    isEqual(
      new Set(permissions),
      new Set(LpInvestorAccessPermissionGroup[key]),
    ),
  );
  if (!presetPermissionsGroup) {
    return returnAsKey ? 'custom' : 'Custom';
  }

  return returnAsKey
    ? presetPermissionsGroup
    : LpInvestorAccessPermissionGroupNames[presetPermissionsGroup];
};

export const getLpInvestorAccessPermissionGroupOptions = () => {
  return (
    Object.keys(
      LpInvestorAccessPermissionGroup,
    ) as Array<LpInvestorAccessPermissionGroupKey>
  ).map((key) => ({
    label: LpInvestorAccessPermissionGroupNames[key],
    value: key,
  }));
};
